import { Controller, useFormContext } from 'react-hook-form';
import { MenuItem } from '@mui/material';
import { Modal, Button, Select } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { MultiAutocomplete } from 'ui/multiAutocomplete/MultiAutocomplete';
import { useSelectedGlc } from 'hooks/useSelectedGlc/useSelectedGlc';
import { useRenderMultiAutocompleteOption } from 'ui/multiAutocomplete/hooks/useRenderMultiAutocompleteOption';
import { Form } from 'ui/form/Form';

import { AddGlcTerminalsFormBody, AddGlcTerminalsProps } from './AddGlcTerminals.types';

export const AddGlcTerminals = ({
  onModalOpen,
  onModalClose,
  isLoading,
  onSubmit,
  isModalOpen,
  isLoadingTerminals,
  terminals,
}: AddGlcTerminalsProps) => {
  const { formatMessage } = useLocale();
  const { renderMultiAutocompleteOption } = useRenderMultiAutocompleteOption();
  const { selectedGlc } = useSelectedGlc();
  const glcServerName = selectedGlc?.rcp.nazwa;

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useFormContext<AddGlcTerminalsFormBody>();

  const isTkdNotSelected = !watch('idTkds')?.length;

  const getOptions = () => {
    return terminals.map((terminal) => ({
      label: terminal.nazwa,
      value: terminal.id,
      number: terminal.numerLogicznyKontrolera,
    }));
  };

  return (
    <>
      <Button onClick={onModalOpen} variant="contained">
        {formatMessage({ id: AppMessages['glc.terminals.add.button'] })}
      </Button>

      <Modal
        header={formatMessage({ id: AppMessages['glc.terminals.add.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        type="form"
        onSubmit={handleSubmit(onSubmit)}
        submitButtonDisabled={isTkdNotSelected || isLoading || !!Object.keys(errors).length}
      >
        <Form.Grid>
          <Select
            required
            disabled
            value={glcServerName}
            label={formatMessage({ id: AppMessages['glc.terminals.add.server.label'] })}
          >
            <MenuItem value={glcServerName}>{glcServerName}</MenuItem>
          </Select>

          <Controller
            name="idTkds"
            control={control}
            render={({ field }) => (
              <MultiAutocomplete
                {...field}
                required
                withLimitedTags
                stopRotatePopupIndicator
                inputSize="big"
                limitTags={1}
                onChange={(_, option) => (option ? field.onChange(option) : field.onChange(null))}
                options={getOptions()}
                loading={isLoadingTerminals}
                loadingText={formatMessage({ id: AppMessages['common.loading'] })}
                label={formatMessage({ id: AppMessages['glc.terminals.add.terminal.label'] })}
                noOptionsText={formatMessage({ id: AppMessages['common.notFound'] })}
                placeholder={formatMessage({ id: AppMessages['glc.terminals.add.terminal.placeholder'] })}
                renderOption={renderMultiAutocompleteOption}
              />
            )}
          />
        </Form.Grid>
      </Modal>
    </>
  );
};
